import React, { useContext, useEffect, useState } from 'react'
import { FaDownload, FaFileAlt, FaFileImage, FaFileVideo, FaRegFilePdf, FaSearch, FaTimes } from 'react-icons/fa'
import { TiThMenu } from 'react-icons/ti'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import AlertContext from '../../../../Context/Alert/AlertContext'
import { BaseURL } from '../../../../Files/BaseURL'
import axios from 'axios'
import SocketContext from '../../../../Context/Socket/SocketContext'
import { formatDateForInput, getFileNameFromUrl } from '../../../../Files/UseFunction'
import ScrollToBottom from "react-scroll-to-bottom";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";
import ThemeContext from '../../../../Context/theme/ThemeContext';
import { IoIosAddCircleOutline } from 'react-icons/io'



const TicketsChat = () => {

    const { theme } = useContext(ThemeContext);
    const { caseid } = useParams()

    const [Evidence, setEvidence] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([]);

    const [Conversation, setConversation] = useState([])
    const [TotalPages, setTotalPages] = useState(null)
    const [Page, setPage] = useState(null)
    const [Chats, setChats] = useState([])
    const [message, setmessage] = useState('')
    const [ChatFile, setChatFile] = useState(null)
    const [FileName, setFileName] = useState(null)
    const [UploadedFile, setUploadedFile] = useState(null)

    const location = useLocation()
    const navigate = useNavigate()

    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;

    const socketcontext = useContext(SocketContext);
    const { SocetConnection } = socketcontext;
    const [offer, setOffer] = useState(null);

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    // Remove a file from the list
    const handleRemoveFile = (fileToRemove) => {
        setSelectedFiles((prevFiles) => prevFiles.filter(file => file !== fileToRemove));
    };

    const fetchconversation = async (id) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/tickets/pending/getMessages/${caseid}`, {
                headers: {
                    'auth-token': authToken,
                }
            });
            if (response.data.success) {
                setConversation(response.data.messages)
                setTotalPages(response.data.totalPages)
                setPage(response.data.page)
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }
    }


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage(e);
        }
    };

    useEffect(() => {
        fetchEvidence();
        fetchconversation()
    }, [])

    const fetchEvidence = async () => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.post(`${BaseURL}/api/tickets/pending/GetEvidence/${caseid}`, {}, {
                headers: {
                    'auth-token': authToken,
                }
            });

            if (response.data.Eveidence) {
                setEvidence(response.data.Eveidence);
            } else {
                showAlert("No evidence found.", 'info');
            }
        } catch (error) {
            console.error("Error fetching evidence:", error);
            showAlert("Failed to fetch evidence.", 'danger');
        }
    }


    const handleUpload = async () => {
        const formData = new FormData();

        selectedFiles.forEach((file) => {
            formData.append('files', file);  // Adjust the 'files' field based on your API
        });

        try {
            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/tickets/pending/UploadEvidence/${caseid}`, {
                method: 'POST',
                body: formData,
                headers: {
                    'auth-token': authToken
                }
            });
            if (response.ok) {
                showAlert('Files uploaded successfully', 'success');
                fetchEvidence()
                setSelectedFiles([]);
            } else {
                showAlert('Error uploading files', 'danger');
            }
        } catch (error) {
            console.error('Error:', error);
            showAlert('Error uploading files', 'danger');
        }
    };


    const renderFileIcon = (file) => {
        const fileType = file?.split('.').pop()?.toLowerCase();

        switch (fileType) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                return <FaFileImage className='text-2xl w-full text-primarygreen' />;
            case 'mp4':
            case 'avi':
            case 'mov':
                return <FaFileVideo className='text-2xl w-full text-primarygreen' />;
            case 'pdf':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'doc':
            case 'docx':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'zip':
            case 'rar':
                return <MdFolderZip className='text-2xl w-full text-gray-400' />;
            default:
                return <FaFileAlt className='text-2xl w-full text-primarygreen' />;
        }
    };

    useEffect(() => {
        if (SocetConnection) {
            const handleMessage = (data) => {
                fetchconversation();
            };
    
            SocetConnection.on('case message', handleMessage);
            SocetConnection.on('case user message', handleMessage);
    
            return () => {
                SocetConnection.off('case message', handleMessage);
                SocetConnection.off('case user message', handleMessage);
            };
        }
    }, [SocetConnection, location.search]);


    const handleSendMessage = async (e) => {
        e.preventDefault()
        if (message !== "") {
            if (SocetConnection) {
                SocetConnection.emit('new user case message', {
                    offercaseid: caseid,
                    covnersation: message,
                })
                setmessage("")
            }
        }
    }

    return (
        <>
            <div className='min-h-full overflow-hidden'>
                <div className={`flex flex-row min-h-[calc(100vh-150px)]`}>
                    <div className={`lg:basis-[30%] w-[100%] h-[100vh] lg:h-auto relative flex flex-col gap-6 py-4 px-6 font-pop ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}>
                        {/* Upload Evidence */}
                        <div className={`flex items-center justify-center h-32 w-full ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}>
                            <label
                                htmlFor="evidence-upload"
                                className={`flex flex-col h-32 items-center justify-center w-full border-2 border-primarygreen border-dashed rounded-lg ${theme === "dark" ? "bg-black text-white border-white" : "bg-white"} cursor-pointer`}
                            >
                                <div className={`flex flex-row gap-4 items-center justify-center py-3 text-primarygreen font-pop`}>
                                    <IoIosAddCircleOutline className="text-2xl" />
                                    <p className={`text-base ${theme === "dark" && "text-white"}`}>
                                        Upload Evidence
                                    </p>
                                </div>
                                <input
                                    id="evidence-upload"
                                    type="file"
                                    multiple
                                    onChange={handleFileChange}
                                    className="hidden"
                                />
                            </label>
                        </div>
                        <div>
                            {selectedFiles.length > 0 && (
                                <ul>
                                    {selectedFiles.map((file, index) => (
                                        <li key={index}>
                                            {file.name}
                                            <button onClick={() => handleRemoveFile(file)} style={{ marginLeft: '10px', color: 'red' }}>
                                                X
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <button
                            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full text-white ${theme === "dark" ? "hover:text-white" : "hover:text-black"}`}
                            onClick={handleUpload}
                        >
                            Upload
                        </button>
                        {/* Display Evidence */}
                        <div className='grid grid-cols-2 gap-2'>
                            {Evidence?.length > 0 ? Evidence.map((item, index) => (
                                <div key={index} className="relative justify-between flex items-center border-2 rounded-lg border-lightGrey py-2 px-2">
                                    {/* Display file icon */}
                                    <div className="flex items-center">
                                        {renderFileIcon(item.src)}
                                        <p className="mt-1">{getFileNameFromUrl(item.src)}</p>
                                    </div>
                                    <a
                                        href={item.src}
                                        download
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaDownload className="text-gray-500 text-lg  hover:text-gray-700" />
                                    </a>
                                </div>
                            )) : (
                                <p className="col-span-3 text-center text-gray-500">No evidence uploaded yet.</p>
                            )}
                        </div>
                    </div>


                    <div className="lg:basis-[70%] hidden lg:block font-pop px-6 py-4">
                        <div className="flex flex-col gap-2 h-[100%] justify-between">
                            <ScrollToBottom className="flex flex-col gap-2">
                                <div className="h-[calc(100vh-260px)]">
                                    <div className="flex flex-col gap-2">
                                        <div className="flex flex-col gap-2">
                                            {Conversation?.length > 0 && Conversation?.map((item, index) => (
                                                <div className={`${item.tag == "Sender" ? "flex flex-col justify-end" : " flex flex-col justify-start"} my-1 gap-1`}>
                                                    {item?.File?.Link
                                                        &&
                                                        <div className={` p-2 rounded w-fit shadow-md font-pop flex items-end ${item.tag == "Sender" ? "bg-primarygreen/50 self-end text-white" : "bg-gray-300"}`}>
                                                            <div className="flex flex-col gap-2">
                                                                {item?.File && renderFileIcon(item?.File?.Link)}
                                                                <span className="ml-2">{item?.File?.Name}</span>
                                                            </div>
                                                            <a href={item?.File?.Link} download={true} target='_blank'>
                                                                <FaDownload
                                                                    className="ml-2 text-3xl text-gray-500 cursor-pointer"
                                                                />
                                                            </a>
                                                        </div>
                                                    }
                                                    <div className={`${item.tag == "Sender" ? "bg-primarygreen self-end text-white" : "bg-[#E8E8E8]"} rounded-xl py-2 px-3 max-w-xs w-fit`}>
                                                        <p className='text-sm md:text-base'>{item?.message}</p>
                                                    </div>
                                                    <p className={`${item.tag == "Sender" ? "text-right" : "text-left"} text-xs`}>{formatDateForInput(item?.date)}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </ScrollToBottom>
                            <div className={`flex flex-row font-pop justify-between items-center  rounded-3xl py-2 px-4 ${theme == "dark" ? "bg-black text-white" : "bg-[#E8E8E8] "} `}>
                                <div className="flex w-[100%] flex-row items-center gap-2">
                                    <div className="flex gap-2 w-full">
                                        <input
                                            type="text"
                                            value={message}
                                            onChange={(e) => { setmessage(e.target.value) }}
                                            placeholder='Message...'
                                            onKeyDown={handleKeyDown}
                                            className='text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent'
                                        />
                                    </div>
                                </div>
                                <img
                                    src="./../../../../../../Assets/Prop/messagesend.png"
                                    alt=""
                                    onClick={handleSendMessage}
                                    className='w-8 h-8 cursor-pointer'
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default TicketsChat